import { injectable } from "inversify";
import "reflect-metadata";

@injectable()
export default class RollingDataService {
    public getImages(): string[] {
        return [
            "/static/images/rolling/A-B CREAR DIBUJO_00027.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00033.png",
            "/static/images/rolling/C-D PARTE ROTACION_00120.png",
            "/static/images/rolling/C-D PARTE ROTACION_00108.png",
            "/static/images/rolling/C-D PARTE ROTACION_00083.png",
            "/static/images/rolling/C-D PARTE ROTACION_00097.png",
            "/static/images/rolling/C-D PARTE ROTACION_00040.png",
            "/static/images/rolling/C-D PARTE ROTACION_00054.png",
            "/static/images/rolling/C-D PARTE ROTACION_00068.png",
            "/static/images/rolling/C-D PARTE ROTACION_00069.png",
            "/static/images/rolling/C-D PARTE ROTACION_00055.png",
            "/static/images/rolling/C-D PARTE ROTACION_00041.png",
            "/static/images/rolling/C-D PARTE ROTACION_00096.png",
            "/static/images/rolling/C-D PARTE ROTACION_00082.png",
            "/static/images/rolling/C-D PARTE ROTACION_00109.png",
            "/static/images/rolling/C-D PARTE ROTACION_00121.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00032.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00026.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00030.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00024.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00018.png",
            "/static/images/rolling/C-D PARTE ROTACION_00123.png",
            "/static/images/rolling/C-D PARTE ROTACION_00094.png",
            "/static/images/rolling/C-D PARTE ROTACION_00080.png",
            "/static/images/rolling/C-D PARTE ROTACION_00057.png",
            "/static/images/rolling/C-D PARTE ROTACION_00043.png",
            "/static/images/rolling/C-D PARTE ROTACION_00042.png",
            "/static/images/rolling/C-D PARTE ROTACION_00056.png",
            "/static/images/rolling/C-D PARTE ROTACION_00081.png",
            "/static/images/rolling/C-D PARTE ROTACION_00095.png",
            "/static/images/rolling/C-D PARTE ROTACION_00122.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00019.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00025.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00031.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00009.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00035.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00021.png",
            "/static/images/rolling/C-D PARTE ROTACION_00126.png",
            "/static/images/rolling/C-D PARTE ROTACION_00091.png",
            "/static/images/rolling/C-D PARTE ROTACION_00085.png",
            "/static/images/rolling/C-D PARTE ROTACION_00052.png",
            "/static/images/rolling/C-D PARTE ROTACION_00046.png",
            "/static/images/rolling/C-D PARTE ROTACION_00047.png",
            "/static/images/rolling/C-D PARTE ROTACION_00053.png",
            "/static/images/rolling/C-D PARTE ROTACION_00084.png",
            "/static/images/rolling/C-D PARTE ROTACION_00090.png",
            "/static/images/rolling/C-D PARTE ROTACION_00127.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00020.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00034.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00008.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00022.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00036.png",
            "/static/images/rolling/C-D PARTE ROTACION_00119.png",
            "/static/images/rolling/C-D PARTE ROTACION_00125.png",
            "/static/images/rolling/C-D PARTE ROTACION_00086.png",
            "/static/images/rolling/C-D PARTE ROTACION_00092.png",
            "/static/images/rolling/C-D PARTE ROTACION_00079.png",
            "/static/images/rolling/C-D PARTE ROTACION_00045.png",
            "/static/images/rolling/C-D PARTE ROTACION_00051.png",
            "/static/images/rolling/C-D PARTE ROTACION_00050.png",
            "/static/images/rolling/C-D PARTE ROTACION_00044.png",
            "/static/images/rolling/C-D PARTE ROTACION_00078.png",
            "/static/images/rolling/C-D PARTE ROTACION_00093.png",
            "/static/images/rolling/C-D PARTE ROTACION_00087.png",
            "/static/images/rolling/C-D PARTE ROTACION_00124.png",
            "/static/images/rolling/C-D PARTE ROTACION_00118.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00037.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00023.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00044.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00050.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00078.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00087.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00093.png",
            "/static/images/rolling/C-D PARTE ROTACION_00023.png",
            "/static/images/rolling/C-D PARTE ROTACION_00037.png",
            "/static/images/rolling/C-D PARTE ROTACION_00036.png",
            "/static/images/rolling/C-D PARTE ROTACION_00022.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00092.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00086.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00079.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00051.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00045.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00053.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00047.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00090.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00084.png",
            "/static/images/rolling/C-D PARTE ROTACION_00034.png",
            "/static/images/rolling/C-D PARTE ROTACION_00020.png",
            "/static/images/rolling/C-D PARTE ROTACION_00008.png",
            "/static/images/rolling/C-D PARTE ROTACION_00009.png",
            "/static/images/rolling/C-D PARTE ROTACION_00021.png",
            "/static/images/rolling/C-D PARTE ROTACION_00035.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00085.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00091.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00046.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00052.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00056.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00042.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00095.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00081.png",
            "/static/images/rolling/C-D PARTE ROTACION_00019.png",
            "/static/images/rolling/C-D PARTE ROTACION_00031.png",
            "/static/images/rolling/C-D PARTE ROTACION_00025.png",
            "/static/images/rolling/C-D PARTE ROTACION_00024.png",
            "/static/images/rolling/C-D PARTE ROTACION_00030.png",
            "/static/images/rolling/C-D PARTE ROTACION_00018.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00080.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00094.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00043.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00057.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00069.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00041.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00055.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00082.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00096.png",
            "/static/images/rolling/C-D PARTE ROTACION_00026.png",
            "/static/images/rolling/C-D PARTE ROTACION_00032.png",
            "/static/images/rolling/C-D PARTE ROTACION_00033.png",
            "/static/images/rolling/C-D PARTE ROTACION_00027.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00097.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00083.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00054.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00040.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00068.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00065.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00071.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00059.png",
            "/static/images/rolling/C-D PARTE ROTACION_00002.png",
            "/static/images/rolling/C-D PARTE ROTACION_00016.png",
            "/static/images/rolling/C-D PARTE ROTACION_00017.png",
            "/static/images/rolling/C-D PARTE ROTACION_00003.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00058.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00070.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00064.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00072.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00066.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00099.png",
            "/static/images/rolling/C-D PARTE ROTACION_00015.png",
            "/static/images/rolling/C-D PARTE ROTACION_00001.png",
            "/static/images/rolling/C-D PARTE ROTACION_00029.png",
            "/static/images/rolling/C-D PARTE ROTACION_00028.png",
            "/static/images/rolling/C-D PARTE ROTACION_00000.png",
            "/static/images/rolling/C-D PARTE ROTACION_00014.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00098.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00067.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00073.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00077.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00063.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00088.png",
            "/static/images/rolling/C-D PARTE ROTACION_00038.png",
            "/static/images/rolling/C-D PARTE ROTACION_00010.png",
            "/static/images/rolling/C-D PARTE ROTACION_00004.png",
            "/static/images/rolling/C-D PARTE ROTACION_00005.png",
            "/static/images/rolling/C-D PARTE ROTACION_00011.png",
            "/static/images/rolling/C-D PARTE ROTACION_00039.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00089.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00062.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00076.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00048.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00060.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00074.png",
            "/static/images/rolling/C-D PARTE ROTACION_00007.png",
            "/static/images/rolling/C-D PARTE ROTACION_00013.png",
            "/static/images/rolling/C-D PARTE ROTACION_00012.png",
            "/static/images/rolling/C-D PARTE ROTACION_00006.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00075.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00061.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00049.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00006.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00012.png",
            "/static/images/rolling/C-D PARTE ROTACION_00115.png",
            "/static/images/rolling/C-D PARTE ROTACION_00101.png",
            "/static/images/rolling/C-D PARTE ROTACION_00129.png",
            "/static/images/rolling/C-D PARTE ROTACION_00061.png",
            "/static/images/rolling/C-D PARTE ROTACION_00075.png",
            "/static/images/rolling/C-D PARTE ROTACION_00049.png",
            "/static/images/rolling/C-D PARTE ROTACION_00048.png",
            "/static/images/rolling/C-D PARTE ROTACION_00074.png",
            "/static/images/rolling/C-D PARTE ROTACION_00060.png",
            "/static/images/rolling/C-D PARTE ROTACION_00128.png",
            "/static/images/rolling/C-D PARTE ROTACION_00100.png",
            "/static/images/rolling/C-D PARTE ROTACION_00114.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00013.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00007.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00011.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00005.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00039.png",
            "/static/images/rolling/C-D PARTE ROTACION_00102.png",
            "/static/images/rolling/C-D PARTE ROTACION_00116.png",
            "/static/images/rolling/C-D PARTE ROTACION_00089.png",
            "/static/images/rolling/C-D PARTE ROTACION_00076.png",
            "/static/images/rolling/C-D PARTE ROTACION_00062.png",
            "/static/images/rolling/C-D PARTE ROTACION_00063.png",
            "/static/images/rolling/C-D PARTE ROTACION_00077.png",
            "/static/images/rolling/C-D PARTE ROTACION_00088.png",
            "/static/images/rolling/C-D PARTE ROTACION_00117.png",
            "/static/images/rolling/C-D PARTE ROTACION_00103.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00038.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00004.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00010.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00028.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00014.png",
            "/static/images/rolling/C-D PARTE ROTACION_00107.png",
            "/static/images/rolling/C-D PARTE ROTACION_00113.png",
            "/static/images/rolling/C-D PARTE ROTACION_00098.png",
            "/static/images/rolling/C-D PARTE ROTACION_00073.png",
            "/static/images/rolling/C-D PARTE ROTACION_00067.png",
            "/static/images/rolling/C-D PARTE ROTACION_00066.png",
            "/static/images/rolling/C-D PARTE ROTACION_00072.png",
            "/static/images/rolling/C-D PARTE ROTACION_00099.png",
            "/static/images/rolling/C-D PARTE ROTACION_00112.png",
            "/static/images/rolling/C-D PARTE ROTACION_00106.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00001.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00015.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00029.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00003.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00017.png",
            "/static/images/rolling/C-D PARTE ROTACION_00110.png",
            "/static/images/rolling/C-D PARTE ROTACION_00104.png",
            "/static/images/rolling/C-D PARTE ROTACION_00058.png",
            "/static/images/rolling/C-D PARTE ROTACION_00064.png",
            "/static/images/rolling/C-D PARTE ROTACION_00070.png",
            "/static/images/rolling/C-D PARTE ROTACION_00071.png",
            "/static/images/rolling/C-D PARTE ROTACION_00065.png",
            "/static/images/rolling/C-D PARTE ROTACION_00059.png",
            "/static/images/rolling/C-D PARTE ROTACION_00105.png",
            "/static/images/rolling/C-D PARTE ROTACION_00111.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00016.png",
            "/static/images/rolling/A-B CREAR DIBUJO_00002.png",
        ]
            .sort((a, b) => {
                return a > b ? 1 : -1;
            })
            .map((item, index) => encodeURI(item));
    }
}



// WEBPACK FOOTER //
// ./src/components/home/parts/rolling-dataservice.ts